import { IgetLoggedUserPermissionsResponse } from '../types/configuration.types';
import { IInfoData } from '../types/global';

export const getNudosData = () => {
  if (localStorage.getItem('userNudosData')) {
    const nudosData: IgetLoggedUserPermissionsResponse = JSON.parse(localStorage.getItem('userNudosData') || '');
    return nudosData;
  }
  return undefined;
};

export const getUserInfoData = () => {
  if (localStorage.getItem('_userInfo')) {
    const infoData: IInfoData = JSON.parse(localStorage.getItem('_userInfo') || '');
    return infoData;
  }
  return undefined;
};
